'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { ImageFieldImage } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import Link from '@/components/atoms/Link';
import RichText from '@/components/atoms/RichText';
import { HEADER_HEIGHT } from '@/consts';
import useHasMounted from '@/hooks/useHasMounted';
import { FacebookIcon, XIcon } from '@/public/assets/svg';
import { preformattedBlogPostSerializer, PrismicSerializer } from '@/utils/prismic/serializer';
import { ArticleContentProps } from './types';
const ArticleContent = t0 => {
  const $ = _c(3);
  const {
    content
  } = t0;
  const isMounted = useHasMounted();
  let t1;
  if ($[0] !== content || $[1] !== isMounted) {
    t1 = isMounted && <div className="o-container o-container--md">{content.sections.length > 0 && <div><h4 className="text-h7 mb-3.5 font-bold text-gray-600">Table of contents</h4><ul className="text-body-7 text-gray-500">{content.sections.map(_temp)}</ul></div>}{content.sections.map(_temp3)}<div className="mt-12 flex flex-row justify-between border-t-[1.5px] border-t-gray-200 pt-8.5"><p className="text-h9 font-semibold text-gray-600">Share</p><div className="flex flex-row gap-3"><Link href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(window.location.href)}`} className="hover:text-primary-600 text-gray-500" target="_blank"><FacebookIcon width="28" height="28" /></Link><Link href={`https://x.com/intent/tweet?text=${encodeURI(content.title as string)}&url=${encodeURI(window.location.href)}`} className="hover:text-primary-600 text-gray-500" target="_blank"><XIcon width="28" height="28" /></Link></div></div></div>;
    $[0] = content;
    $[1] = isMounted;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ArticleContent;
function _temp(section, index) {
  return <li key={section.header} className="text-link-1 pl-1 font-medium text-gray-500"><div className="mb-4 flex flex-row gap-1"><p>{index + 1}.</p><a href={`#${section.header as string}`} className="hover:text-primary-600 cursor-pointer underline" onClick={event => {
        const header = document.getElementById(section.header as string);
        if (!header) {
          return;
        }
        event.preventDefault();
        window.scrollTo({
          top: header?.offsetTop - HEADER_HEIGHT,
          behavior: "smooth"
        });
      }}>{section.header}</a></div></li>;
}
function _temp2(t0) {
  const {
    node
  } = t0;
  return <div className="mt-12"><PrismicNextImage fallbackAlt="" field={node as unknown as ImageFieldImage} className="rounded-[.625rem]" /><div className="border-l-primary-600 mt-3 border-l-2 pl-2"><p className="text-body-8 text-gray-500">{node.alt || ""}</p></div></div>;
}
function _temp3(section_0) {
  return <div key={section_0.header}><h3 className="text-h5 lg:text-h3 mt-12 mb-4 font-bold text-gray-600" id={section_0.header as string}>{section_0.header}</h3><div className="blog-rich-text text-body-7 text-gray-500"><RichText field={section_0.content} components={{
        ...PrismicSerializer,
        image: _temp2,
        preformatted: preformattedBlogPostSerializer
      }} /></div></div>;
}